import { GetResources } from "./scripts/ResourceManager.js";
import { AuthenticationContext, adalFetch, withAdalLogin } from 'react-adal';

const resources = GetResources();
export const adalConfigOptions = fetch('api/admin/Admin/GetAdalConfig').then(response => response.json())
    .then(config => {      
        config.redirectUri = window.location.origin;
        config.postLogoutRedirectUri = window.location.origin;
        var authContext = new AuthenticationContext(config);
        var adalApiFetch = (fetch, url, options) =>
            adalFetch(authContext, config.endpoints.api, fetch, url, options);
        var withAdalLoginApi = withAdalLogin(authContext, config.endpoints.api);

    
        var configValues = {
            adalConfig : config,
            authContext: authContext,
            adalApiFetch: adalApiFetch,
            withAdalLoginApi: withAdalLogin(authContext, config.endpoints.api),
            authGroup: config.authGroup
        }
        return configValues;
    });

//export const adalConfig = {
//    tenant: '36da45f1-dd2c-4d1f-af13-5abe46b99921',
//    clientId: '1a4b6c33-ae71-436d-a9a8-a1904fca83ed',
//    endpoints: {
//        // api: 'https://localhost:44323',
//        api: 'https://graph.microsoft.com'
//    },
//    redirectUri: window.location.origin,
//    // redirectUri: 'https://localhost:44342',
//    postLogoutRedirectUri: window.location.origin,
//    cacheLocation: 'localStorage',
//};

//export const authContext = new AuthenticationContext(adalConfig);

//export const adalApiFetch = (fetch, url, options) =>
//    adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

//export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);



// WEBPACK FOOTER //
// ./src/adalConfig.js